module.exports = __webpack_public_path__ + "img/slider-image-4.7b99b1c2.jpg";